// === store/index.js ===
// Baseado no código oficial do Traccar Web
// + adaptações otimizadas para projeto customizado (revendas, costs, users, stopped, positions)

import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { errorsReducer as errors } from './errors';
import { sessionReducer as session, sessionActions } from './session';
import { devicesReducer as devices, devicesActions } from './devices';
import { eventsReducer as events, eventsActions } from './events';
import { geofencesReducer as geofences } from './geofences';
import { groupsReducer as groups } from './groups';
import { positionsReducer as positions } from './positions';
import { driversReducer as drivers } from './drivers';
import { maintenancesReducer as maintenances } from './maintenances';
import { calendarsReducer as calendars } from './calendars';

/** Custom modules (MOD) */
import { revendasReducer as revendas } from './revendas';
import { costsReducer as costs } from './costs';
import { usersReducer as users } from './users';
import { stoppedReducer as stopped } from './stoppedSlice';
import { dashboardReducer as dashboard } from './dashboard';
import { poisReducer as pois } from './pois';

import throttleMiddleware from './throttleMiddleware';

// --- Combined Reducer ---
const reducer = combineReducers({
  errors,
  session,
  devices,
  positions,
  events,
  geofences,
  groups,
  drivers,
  maintenances,
  calendars,
  /** Custom reducers */
  revendas,
  costs,
  users,
  stopped,
  dashboard,
  pois,
});

// --- Actions Exports ---
export { errorsActions } from './errors';
export { sessionActions } from './session';
export { devicesActions } from './devices';
export { positionsActions } from './positions';
export { eventsActions } from './events';
export { geofencesActions } from './geofences';
export { groupsActions } from './groups';
export { driversActions } from './drivers';
export { maintenancesActions } from './maintenances';
export { calendarsActions } from './calendars';
export { revendasActions } from './revendas';
export { costsActions } from './costs';
export { usersActions } from './users';
export { stoppedActions } from './stoppedSlice';
export { dashboardActions } from './dashboard';
export { poisActions } from './pois';

// --- Memoized Selectors ---
export {
  // Input selectors
  selectDevicesItems,
  selectSelectedDeviceId,
  selectSessionPositions,
  selectSessionHistory,
  selectEventsItems,
  selectGroupsItems,
  selectServer,
  selectUser,
  // Derived selectors
  selectDevicesArray,
  selectDeviceIds,
  selectDevicesCount,
  selectSelectedDevice,
  selectSelectedPosition,
  selectSelectedDeviceWithPosition,
  selectDeviceStatusCounts,
  selectPositionsArray,
  selectEventsArray,
  selectDevicesByGroup,
  selectOnlineDevices,
  selectOfflineDevices,
  // Factory selectors
  makeSelectDeviceById,
  makeSelectPositionByDeviceId,
  // Hooks
  useDevices,
  useDeviceIds,
  useDevicesCount,
  useSelectedDevice,
  useSelectedPosition,
  useSelectedDeviceWithPosition,
  useDeviceStatusCounts,
  usePositions,
  useEvents,
  useDevicesByGroup,
} from './selectors';

// --- Optimized Middleware Configuration ---
// 2ECOMP: Desabilita checks em dev para melhor performance com 3000+ devices
// Estes checks são automaticamente desabilitados em produção pelo Redux Toolkit
const isDev = process.env.NODE_ENV === 'development';

export default configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Desabilita em dev - muito lento com 3000+ devices
      serializableCheck: isDev ? false : {
        warnAfter: 200,
        ignoredActions: [
          devicesActions.update?.type,
          sessionActions.updatePositions?.type,
          eventsActions.add?.type,
        ],
        ignoredPaths: [
          'session.positions',
          'devices.items',
          'events.items',
          'events.byId',
          'session.logs',
        ],
      },
      immutableCheck: isDev ? false : {
        warnAfter: 200,
        ignoredPaths: [
          'session.positions',
          'devices.items',
          'events.items',
          'events.byId',
        ],
      },
    }).concat(throttleMiddleware),
});
